/** Serialize the rendered documentation, including every code-example tab. */
export function documentMarkdown(root) {
  const inline = node => Array.from(node.childNodes || []).map(render).join('');
  function render(node) {
    if (node.nodeType === 3) return node.textContent || '';
    if (node.nodeType !== 1) return '';
    const attr = name => node.getAttribute(name);
    if (attr('data-markdown-exclude') !== null || ['BUTTON', 'SELECT', 'TEXTAREA'].includes(node.tagName)) return '';
    const override = attr('data-markdown');
    if (override !== null) return '\n\n' + override + '\n\n';
    const text = inline(node);
    if (/^H[1-6]$/.test(node.tagName)) return '\n\n' + '#'.repeat(Number(node.tagName.slice(1))) + ' ' + text.trim() + '\n\n';
    if (node.tagName === 'PRE') {
      const code = node.textContent || '';
      const fence = '`'.repeat(Math.max(3, ...Array.from(code.matchAll(/`+/g), match => match[0].length + 1)));
      return '\n\n' + fence + '\n' + code + '\n' + fence + '\n\n';
    }
    if (node.tagName === 'CODE') return '`' + text.replaceAll('`', '\\`') + '`';
    if (node.tagName === 'STRONG') return '**' + text + '**';
    if (node.tagName === 'A') return '[' + text.trim() + '](' + (attr('href') || '') + ')';
    if (node.tagName === 'LI') return '- ' + text.trim() + '\n';
    if (node.tagName === 'DT') return '\n\n**' + text.trim() + '**: ';
    if (node.tagName === 'TR') {
      const cells = Array.from(node.children).filter(c => ['TD', 'TH'].includes(c.tagName));
      const row = '| ' + cells.map(c => inline(c).trim().replaceAll('|', '\\|').replace(/\n/g, '<br>')).join(' | ') + ' |\n';
      return row + (cells.some(c => c.tagName === 'TH') ? '| ' + cells.map(() => '---').join(' | ') + ' |\n' : '');
    }
    if (['P', 'SECTION', 'TABLE', 'UL', 'OL', 'DIV', 'FOOTER'].includes(node.tagName)) return '\n\n' + text.trim() + '\n\n';
    if (node.tagName === 'BR') return '\n';
    return text;
  }
  return render(root).replace(/\n{3,}/g, '\n\n').trim() + '\n';
}
